module.exports = __webpack_public_path__ + "img/legal-document.44dc0dc4.png";